
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Awards from "../pages/awards/page";
import Contact from "../pages/contact/page";
import ProjectDetail from "../pages/project/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/awards",
    element: <Awards />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/project/:id",
    element: <ProjectDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
